import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "ml-3 control-label",
    for: "inputConfirmationEmail"
};
const _hoisted_2 = { class: "col-sm-10" };
const _hoisted_3 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_4 = {
    key: 1,
    class: "error form-group__message"
};
const _hoisted_5 = { class: "px-3" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["BModal"], {
        ref: "resendConfirmationModal",
        centered: "",
        "no-footer": "",
        size: "lg",
        title: _ctx.$t('JTADM_USERS_ACCOUNT_TROUBLESHOOTING')
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", {
                class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.email.$error }])
            }, [
                _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('JTADM_EMAIL')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        id: "inputConfirmationEmail",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.resendEmailForm.email) = $event)),
                        type: "email",
                        onInput: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => ($setup.v$.email.$touch && $setup.v$.email.$touch(...args)))
                    }, null, 544), [
                        [_vModelText, $setup.resendEmailForm.email]
                    ]),
                    ($setup.v$.email.$error && $setup.v$.email.required?.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_EMAIL')), 1))
                        : ($setup.v$.email.$error && $setup.v$.email.email?.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('JTADM_INVALID_EMAIL_ADDRESS')), 1))
                            : _createCommentVNode("", true)
                ])
            ], 2),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('JTADM_USERS_TROUBLESHOOT_RESET')), 1),
                _createElementVNode("button", {
                    class: "btn btn-danger mb-3",
                    type: "submit",
                    disabled: $setup.v$.email.$invalid,
                    onClick: _withModifiers($setup.resetPassword, ["prevent"])
                }, _toDisplayString(_ctx.$t('JTADM_RESET_PASSWORD')), 9, _hoisted_6),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('JTADM_USERS_TROUBLESHOOT_CONFIRM')), 1),
                _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "submit",
                    disabled: $setup.v$.email.$invalid,
                    onClick: _withModifiers($setup.resendConfirmation, ["prevent"])
                }, _toDisplayString(_ctx.$t('JTADM_USERS_RESEND_CONFIRM')), 9, _hoisted_7)
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
